import { baseApi } from "./baseApi";

export interface UploadImageData {
	images: string[]; // Array of base64 encoded images
	folder?: string; // Optional folder name in Cloudinary
}

export interface UploadedImage {
	url: string;
	public_id: string;
	format: string;
	width: number;
	height: number;
}

export interface UploadImageResponse {
	uploaded: UploadedImage[];
	failed: Array<{ index: number; error: string }>;
	message: string;
}

export interface DeleteImageData {
	public_id: string; // Cloudinary public_id
}

export interface DeleteImageResponse {
	message: string;
}

/**
 * Image Upload API endpoints
 */
export const imageUploadApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		/**
		 * Upload image to Cloudinary
		 */
		uploadImage: builder.mutation<UploadImageResponse, UploadImageData>({
			query: (data) => ({
				url: "/images/upload/",
				method: "POST",
				body: {
					images: data.images,
					folder: data.folder || "uploads",
				},
			}),
		}),

		/**
		 * Delete image from Cloudinary
		 */
		deleteImage: builder.mutation<DeleteImageResponse, DeleteImageData>({
			query: (data) => ({
				url: "/images/delete/",
				method: "POST",
				body: {
					public_id: data.public_id,
				},
			}),
		}),
	}),
});

/**
 * Export hooks for usage in functional components
 */
export const { useUploadImageMutation, useDeleteImageMutation } =
	imageUploadApi;
